import { useLabel } from '../../../../hooks/useLabel';
import { CATEGORIES } from '../../../../shared/consts';
import type { Category } from '../../../../shared/types';

type Result = ModelHookResult<
	{
		categories: readonly Category[];
	},
	{
		getLabel: ReturnType<typeof useLabel>['actions']['getLabel'];
	}
>;

export function useCategoryField(): Result {
	const {
		actions: { getLabel },
	} = useLabel('category');

	return {
		data: {
			categories: CATEGORIES,
		},
		actions: {
			getLabel,
		},
	};
}
